import React from "react";
import { Typography } from "antd";

const { Title } = Typography;

interface AgentPageHeaderProps {
  title: string;
  agentName?: string | null;
}

/** Shared page title used across agent list pages (Bookings, Containers, Master BL/AWB). */
export const AgentPageHeader: React.FC<AgentPageHeaderProps> = ({
  title,
  agentName,
}) => (
  <Title level={3} style={{ marginTop: 0 }}>
    {title}
    {agentName ? ` — ${agentName}` : ""}
  </Title>
);
